import {
  CircularProgress,
  Theme,
  Typography,
  withStyles
} from '@material-ui/core'
import { FC } from 'react'
import Dropzone, { DropzoneOptions } from 'react-dropzone'
import { Trans } from 'react-i18next'
import { Field } from 'redux-form'
import uploadImage from '../../../images/uploadImage.png'
import { MuiClasses } from '../../../types'
import { DropzoneImageFile, ImageFileWithObjectURL } from '../../../types/files'
import ErrorMessage from '../../Error/ErrorMessage'

const styles = ({ spacing }: Theme) => ({
  error: {
    color: 'red'
  },
  list: {
    maxWidth: 400,
    overflow: 'auto',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  listItem: {
    textAlign: 'center' as any,
    padding: 0
  },
  uploadIcon: {
    margin: 10
  },
  uploadArea: {
    height: 250,
    backgroundColor: '#E7F6E5',
    textAlign: 'center' as any,
    cursor: 'pointer',
    padding: spacing(),
    borderRadius: '25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

interface FieldProps {
  name: string
  label: string
  /** see props from https://react-dropzone.js.org/ */
  dropzoneOptions: DropzoneOptions
  beforeLogin?: true
  submitForm: any
  submittingMedia?: boolean
}

interface FileInputProps extends FieldProps {
  input: {
    onChange: any
    value: any
  }
  dropzoneOptions: DropzoneOptions
  meta: {
    error: string
  }
  label: string
  classes: MuiClasses
}

const getFilesWithObjectURLS = (files: DropzoneImageFile[]) =>
  files.map((file) => {
    const objectURL = URL.createObjectURL(file)
    const fileWithObjectUrl: ImageFileWithObjectURL = {
      ...file,
      key: objectURL,
      src: objectURL
    }
    return fileWithObjectUrl
  })

const CustomDropZone: FC<FileInputProps> = ({
  input: { onChange },
  dropzoneOptions,
  meta: { error: metaError },
  label,
  classes,
  beforeLogin,
  submitForm,
  submittingMedia
}) => (
  <Dropzone
    onDrop={(filesToUpload) => {
      if (beforeLogin) {
        const filesWithObjectURL = getFilesWithObjectURLS(
          (filesToUpload as unknown) as DropzoneImageFile[]
        )
        onChange(filesWithObjectURL)
        submitForm()
      } else {
        onChange(filesToUpload)
        submitForm()
      }
    }}
    {...dropzoneOptions}
  >
    {({ getRootProps, getInputProps }) => (
      <div
        {...getRootProps()}
        style={{ flexDirection: 'column' }}
        className={classes.uploadArea}
      >
        <input {...getInputProps()} />
        {submittingMedia && !beforeLogin ? (
          <CircularProgress
            size={72}
            style={{ color: '#4f9b44', margin: '25px' }}
          />
        ) : (
          <img src={uploadImage} className={classes.uploadIcon} />
        )}

        {/* <UploadIcon size={30} className={classes.uploadIcon} /> */}

        {label && (
          <Typography variant='subtitle1' gutterBottom>
            <Trans>{label}</Trans>
          </Typography>
        )}
        <ErrorMessage error={metaError} />
      </div>
    )}
  </Dropzone>
)

/** Uses old function format to manage react displayName rule with eslint
 *
 * https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/display-name.md
 * https://github.com/yannickcr/eslint-plugin-react/issues/597
 */
function FileInput(props: FieldProps) {
  return <Field {...props} component={withStyles(styles)(CustomDropZone)} />
}

export default FileInput
